import { apiFetch } from './api';

// COA core
export function listCOAs({ search = '', tag = '', page = 1, limit = 20 } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (tag) params.set('tag', tag);
  params.set('page', String(page));
  params.set('limit', String(limit));
  const q = params.toString() ? `?${params.toString()}` : '';
  return apiFetch(`/api/admin/coas${q}`);
}

export function createCOA(payload) {
  return apiFetch('/api/admin/coas', { method: 'POST', body: payload });
}

export function getCOA(id) {
  return apiFetch(`/api/admin/coas/${id}`);
}

export function updateCOA(id, payload) {
  return apiFetch(`/api/admin/coas/${id}`, { method: 'PATCH', body: payload });
}

export function deleteCOA(id) {
  return apiFetch(`/api/admin/coas/${id}`, { method: 'DELETE' });
}

export function publishCOA(id) {
  return apiFetch(`/api/admin/coas/${id}/publish`, { method: 'POST' });
}

export function archiveCOA(id) {
  return apiFetch(`/api/admin/coas/${id}/archive`, { method: 'POST' });
}

export function previewCOA(id) {
  return apiFetch(`/api/admin/coas/${id}/preview`);
}

// Terms & Conditions
export function getCOATerms(id) {
  return apiFetch(`/api/admin/coas/${id}/terms`);
}

export function putCOATerms(id, { permissionsToUse, restrictions }) {
  return apiFetch(`/api/admin/coas/${id}/terms`, { method: 'PUT', body: { permissionsToUse, restrictions } });
}

// Translations
export function listTranslations(coaId) {
  return apiFetch(`/api/admin/coas/${coaId}/translations`);
}

export function createTranslation(coaId, payload) {
  return apiFetch(`/api/admin/coas/${coaId}/translations`, { method: 'POST', body: payload });
}

export function updateTranslation(translationId, payload) {
  return apiFetch(`/api/admin/coas/translations/${translationId}`, { method: 'PATCH', body: payload });
}

export function deleteTranslation(translationId) {
  return apiFetch(`/api/admin/coas/translations/${translationId}`, { method: 'DELETE' });
}

// Documents
export function listDocuments(coaId) {
  return apiFetch(`/api/admin/coas/${coaId}/documents`);
}

export function createDocument(coaId, payload) {
  return apiFetch(`/api/admin/coas/${coaId}/documents`, { method: 'POST', body: payload });
}

export function updateDocument(docId, payload) {
  return apiFetch(`/api/admin/coas/documents/${docId}`, { method: 'PATCH', body: payload });
}

export function deleteDocument(docId) {
  return apiFetch(`/api/admin/coas/documents/${docId}`, { method: 'DELETE' });
}

// Fees
export function getFees(coaId) {
  return apiFetch(`/api/admin/coas/${coaId}/fees`);
}

export function putFees(coaId, rows) {
  return apiFetch(`/api/admin/coas/${coaId}/fees`, { method: 'PUT', body: { rows } });
}

// FAQs
export function listFAQs(coaId) {
  return apiFetch(`/api/admin/coas/${coaId}/faqs`);
}

export function createFAQ(coaId, payload) {
  return apiFetch(`/api/admin/coas/${coaId}/faqs`, { method: 'POST', body: payload });
}

export function updateFAQ(faqId, payload) {
  return apiFetch(`/api/admin/coas/faqs/${faqId}`, { method: 'PATCH', body: payload });
}

export function deleteFAQ(faqId) {
  return apiFetch(`/api/admin/coas/faqs/${faqId}`, { method: 'DELETE' });
}

// Uploads
export function presignUpload({ filename, contentType }) {
  return apiFetch('/api/admin/uploads/presign', { method: 'POST', body: { filename, contentType } });
}

export async function uploadFileAndGetUrl(file) {
  if (!file) throw new Error('No file');
  const presign = await presignUpload({ filename: file.name, contentType: file.type || 'application/octet-stream' });
  const putRes = await fetch(presign.uploadUrl, { method: 'PUT', headers: { 'Content-Type': file.type || 'application/octet-stream' }, body: file });
  if (!putRes.ok) throw new Error(`Upload failed: ${putRes.status}`);
  return presign.fileUrl;
}


